export enum VerifyType {
  ConfirmEmail = 'email',
  PasswordReset = 'recovery',
  ChangeEmail = 'change-email',
  Unknown = '',
}

export const EMAIL_SUBJECTS: Record<VerifyType, string> = {
  [VerifyType.ConfirmEmail]: 'Verify your email',
  [VerifyType.PasswordReset]: 'Reset your password',
  [VerifyType.ChangeEmail]: 'Verify your new email',
  [VerifyType.Unknown]: '',
}

// Sent instead of a change-email code when the new address already has an account.
export const ACCOUNT_EXISTS_EMAIL_SUBJECT = 'This email already has an Argus account'
